var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablerDeviceComputerCamera = function SvgTablerDeviceComputerCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.167 8.333a5.834 5.834 0 1 0 11.667 0 5.834 5.834 0 0 0-11.667 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6.667 13.333-1.743 2.905a.833.833 0 0 0 .714 1.262h8.724a.833.833 0 0 0 .714-1.262l-1.743-2.905m-5.833-5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0"
  })));
};
export default SvgTablerDeviceComputerCamera;